const updateCart = theme.ajaxCart.update; // Default way to update cart

// Custom attribute to mark items added by the discount-progress
const AUTO_ADDED_ATTRIBUTE = "_auto_added_reward";
let thresholdRewardIds = {};
// Get reward product IDs for each threshold, may be undefined if not set
const getThresholdRewardIds = () => {
  const rewardIds = {};
  $(".discount-bar__threshold").each(function () {
    const index = $(this).data("index");
    const rewardId = $(this).data("reward-product-id");
    if (rewardId) {
      rewardIds[index] = rewardId;
    }
  });
  return rewardIds;
};

// function initDiscountProgressBar() {
//   // Flag to prevent infinite update loops
//   let isUpdating = false;

//   // Function to update progress bar with current cart data
//   function updateProgressBar() {
//     if (isUpdating) return; // Skip if already updating

//     const discountProgressBars = $('discount-progress-bar');
//     if (discountProgressBars.length) {
//       isUpdating = true;
//       const currency = $('#CartDrawer[data-currency-symbol]').attr('data-currency-symbol').replace('0,00', '').replace('0.00', '');
//       jQuery.getJSON("/cart.js", cart => {
//         // Update each progress bar independently
//         discountProgressBars.each(function (index) {
//           const currentBar = $(this);
//           updateDiscountProgressBar(cart, currency, currentBar, index);
//         });

//         // Reset flag after a short delay to allow DOM to settle
//         setTimeout(() => {
//           isUpdating = false;
//         }, 100);
//       });
//     }
//   }

//   // Listen for changes to the cart form
//   $(document).on('change', '#ajaxCartForm', updateProgressBar);

//   // Listen for DOM changes within CartContainer (for AJAX updates)
//   const observer = new MutationObserver(function (mutations) {
//     // Only process if we're not already updating
//     if (!isUpdating) {
//       for (const mutation of mutations) {
//         // Check if this is a relevant mutation (not caused by our own updates)
//         if (mutation.type === 'childList' &&
//           !mutation.target.closest('.discount-bar__progress-fill') &&
//           !mutation.target.closest('.discount-bar__status')) {
//           updateProgressBar();
//           break;
//         }
//       }
//     }
//   });

//   const cartContainer = document.querySelector('#CartContainer');
//   if (cartContainer) {
//     observer.observe(cartContainer, {
//       childList: true,
//       subtree: true
//     });
//   }

//   // Initialize on page load
//   updateProgressBar();
// }

function initDiscountProgressBar() {
  const discountProgressBar = $("discount-progress-bar");
  if (discountProgressBar.length > 0) {
    const currency = $("#CartDrawer[data-currency-symbol]")
      .attr("data-currency-symbol")
      .replace("0,00", "")
      .replace("0.00", "");
    jQuery.getJSON("/cart.js", (cart) => {
      updateDiscountProgressBar(cart, currency, discountProgressBar);
    });
  }
}

function refreshCartDrawer(shippingProtection = false) {
  $.get(window.location.pathname, function (response) {
    const updatedCartDrawer = $(response).find("#CartDrawer");
    $("#CartDrawer").html(updatedCartDrawer.html());

    if (!shippingProtection) initDiscountProgressBar();

    // Hide controls for auto-added reward products after cart is refreshed
    setTimeout(function () {
      $(".drawer-cart-pd").removeClass("loading");
    }, 500);
  });
}
window.refreshCartDrawer = refreshCartDrawer;

$(document).ready(function () {
  const log = window.log;
  console.log(
    "%cCart script launched!",
    "background: blue; color: white; padding: 2px 6px; border-radius: 3px"
  );

  // Common utility functions
  // Handle cart AJAX requests with standardized error handling
  function cartRequest(url, data, loadingElement, callback) {
    if (loadingElement) $(loadingElement).addClass("loading");

    return jQuery.ajax({
      type: "POST",
      url: url,
      data: data,
      dataType: "json",
      success: function (response) {
        log.collapse(response, "Cart Request Success", "success");
        if (loadingElement) $(loadingElement).removeClass("loading");
        callback ? callback(response) : refreshCartDrawer();
      },
      error: function (jqxhr, status, exception) {
        log.collapse({ status, exception }, "Cart Request Error", "error");
      },
    });
  }
  window.cartRequest = cartRequest;

  // Update cart quantity for an item
  function updateCartQuantity(elementContext, newQuantity) {
    const $context = $(elementContext);
    const $row = $context.closest(".cart__row");
    const currentId = $row.data("product-variant-id");
    const currentVal = parseFloat($row.find(".cart__product-qty").val());
    log.collapse(
      { currentId, currentVal, newQuantity },
      "Update Cart Quantity"
    );

    $row.addClass("loading");

    cartRequest("/cart/change.js", {
      id: currentId,
      quantity: currentVal + newQuantity,
    });
  }

  // Event handlers
  // Product form submission
  $(document).on("submit", ".product-single__form", function () {
    setTimeout(function () {
      $(".js-drawer-open-button-right").trigger("click");
      refreshCartDrawer();
      $(".btn--add-to-cart").removeClass("btn--loading");
      $(".btn--add-to-cart").prop("disabled", false);
    }, 2000);
  });

  function addToCart($popupBtn) {
    // Reset Popup
    $(".popup-upsell:not(body)").removeClass("active");

    const isBundle = $(".product-btn__adtocart").attr("data-type") == "bundle";
    const urlParams = new URLSearchParams(window.location.search);
    var mainSellingId;
    const mainId =
      $(".product-single__variants").val() || $('.adev-variant.active').data("variant-id") || urlParams.get("variant");
    if (isBundle) {
      mainSellingId =
        $(".rc-selling-plans-dropdown__select").val() ||
        urlParams.get("selling_plan") ||
        undefined;
    } else {
      if ($(".pp_var_autoship").hasClass("disabled")) {
        mainSellingId = undefined;
      } else {
        mainSellingId = $(
          '.pp_var-subs-details[data-id="' + mainId + '"]'
        ).attr("data-sub-plan");
      }
    }

    let items = [{ id: mainId, quantity: 1, selling_plan: mainSellingId }];
    log.collapse({ items }, "Add to Cart Default", "info");

    // Add bundle items to cart

    if (isBundle) {
      items = [];
      const mode = $(".pp_bundle_option.pp_bundle_selected").attr("mode");
      $(".pp_builder_var_qty.hasItem").each(function () {
        const itemId = $(this).attr("data-id");
        const itemQty = $(this).find(".pp_var_qty_value").html();
        const itemSellingPlan = $(this).attr("data-selling-plan");

        const item = {
          id: itemId,
          quantity: itemQty,
          selling_plan: mode == "sub" ? itemSellingPlan : undefined,
        };
        items.push(item);
      });

      log.collapse({ items }, "Add Bundle to Cart", "info");
    }

    // Add popup upsell item to cart
    if ($popupBtn) {
      const $popupBtnEl = $popupBtn || $(".popup-upsell__button-atc");
      const upsellId = $popupBtnEl.data("id");

      items.push({ id: upsellId, quantity: 1 });
      log.collapse({ items }, "Add Popup Upsell to Cart", "info");
    }

    cartRequest("/cart/add.js", { items }, null, function (res) {
      refreshCartDrawer();
      timber.CartDrawer = new timber.Drawers("CartDrawer", "right");
      timber.CartDrawer.open();
    });
  }

  // ====================== PDP Popup Upsell ========================
  async function checkIfUpsellInCart() {
    const cart = await window._pf_getCart();
    const cartItems = cart.items;
    const upsellId = $(".popup-upsell__button-atc").data("id");
    const upsellInCart = cartItems.some((item) => item.id === upsellId);
    log.collapse({ upsellInCart, cartItems, upsellId }, "Upsell in Cart");
    return upsellInCart;
  }

  if ($(".popup-upsell__button-atc").length > 0) {
    log.collapse(true, "Popup Upsell Exists");

    $(".popup-upsell__button-atc").on("click", function (e) {
      e.preventDefault();
      addToCart($(this));
    });

    $(".popup-upsell__button-decline").on("click", function (e) {
      e.preventDefault();
      addToCart();
    });
  }

  // ====================== ATC Click Handler ========================
  const ATCButtons = [
    ".product-single__add-to-cart .btn--add-to-cart",
    ".product-single__add-to-cart .product-btn__adtocart",
    '.product-btn__adtocart[data-type="bundle"]',
  ];

  $(ATCButtons.join(",")).on("click", async function (e) {
    e.preventDefault();
    const popupUpsellATC = $(".popup-upsell__button-atc");
    const isProductUpsellProduct =
      parseInt(popupUpsellATC.data("product-id")) ==
      parseInt($(".product-single__variants").data("productid"));
    const upsellInCart = await checkIfUpsellInCart();
    log.collapse(
      {
        isProductUpsellProduct,
        isPopupUpsell: popupUpsellATC.length > 0,
        upsellInCart,
      },
      "ATC Popup Upsell Handler"
    );

    if (popupUpsellATC.length > 0 && !isProductUpsellProduct && !upsellInCart) {
      $(".popup-upsell:not(body)").addClass("active");
      $(".accordion > .accordion-item").children(".accordion-panel").slideUp();
      $(".accordion > .accordion-item.is-active")
        .children(".accordion-panel")
        .slideDown();
    } else {
      addToCart();
    }
  });

  // ===================== Essential Functions ========================
  // Checkout button
  $(document).on("click", ".btn--checkout", function () {
    window.location.href = "/checkout";
  });

  // Quantity increase and decrease
  $(document)
    .on(
      "click",
      ".js-qty__adjust--plus, .qty-adjust__Cart.qty-plus",
      function () {
        updateCartQuantity(this, 1);
      }
    )
    .on(
      "click",
      ".js-qty__adjust--minus, .qty-adjust__Cart.qty-minus",
      function () {
        updateCartQuantity(this, -1);
      }
    );

  // Modal close
  $(document).on("click", ".js-modal-close", () =>
    $(".overlay-drawer").trigger("click")
  );

  // Remove item from cart
  $(document).on("click", ".cart-product-remove", function () {
    $(this).closest(".cart__row").addClass("loading");
    cartRequest("/cart/change.js", {
      id: $(this).attr("data-id"),
      quantity: 0,
    });
  });

  // ===================== Add Upsell to Cart ========================
  $(document).on("click", ".cd_upsell_add_btn", function () {
    $(this).closest(".cd_upsell_item").addClass("loading");
    cartRequest("/cart/add.js", {
      id: $(this).attr("data-id"),
      quantity: 1,
    });
  });

  // ===================== Shipping Protection ========================
  $(document).on("click", ".nrcs_checking", function () {
    const $config = $(".data_protection_config");
    const currentValue = $config.attr("data-protection");
    $config.attr("data-protection", currentValue == "1" ? "0" : "1");
  });

  // Handle protection updates
  function updateProtection(updates) {
    // Validate updates object before proceeding
    if (
      !updates ||
      typeof updates !== "object" ||
      Object.keys(updates).length === 0 ||
      Object.keys(updates)[0] === "undefined"
    )
      return;

    $(".nr_cart_shipping_prot").addClass("loading");
    cartRequest("/cart/update.js", { updates: updates });
  }

  // Initialize and manage shipping protection
  function initProtection() {
    jQuery.getJSON("/cart.js", function (cart) {
      const data_id = $(".nr_cart_shipping_prot").attr("data-id");
      let data_qty = 0;
      let otherItemsInCart = 0;

      // Count items by type
      cart.items.forEach((item) => {
        if (item.id == data_id) {
          data_qty += item.quantity;
        } else {
          otherItemsInCart += item.quantity;
        }
      });

      // Only process if cart has items
      if (cart.item_count > 0) {
        // Create updates object for cart changes
        const updates = {};
        let logData = {
          shouldLog: false,
          data_qty,
          otherItemsInCart,
          message: "",
        };
        // Case 1: If cart only has protection items but no other items
        if (otherItemsInCart < 1 && data_qty > 0) {
          updates[data_id] = 0;
          updateProtection(updates);
          logData = {
            ...logData,
            message:
              "Case 1: Cart only has protection items but no other items",
            shouldLog: true,
          };
        }
        // Case 2: If protection is disabled but we have protection in cart
        else if ($(".nrcs_checking").hasClass("disabledBtn") && data_qty > 0) {
          updates[data_id] = 0;
          updateProtection(updates);
          logData = {
            ...logData,
            message:
              "Case 2: Protection is disabled but we have protection in cart",
            shouldLog: true,
          };
        }
        // Case 3: If protection is enabled but missing from cart
        else if (
          !$(".nrcs_checking").hasClass("disabledBtn") &&
          data_qty == 0
        ) {
          updates[data_id] = 1;
          updateProtection(updates);
          logData = {
            ...logData,
            message: "Case 3: Protection is enabled but missing from cart",
            shouldLog: true,
          };
        }
        if (logData.shouldLog)
          log.collapse(logData, "Shipping Protection", "info");
      }
    });
  }

  // Toggle protection switch based on data attribute
  function toggleSwitchDefault() {
    const position = $(".data_protection_config").attr("data-protection");
    $(".nrcs_checking")[position == "1" ? "removeClass" : "addClass"](
      "disabledBtn"
    );
  }

  // Set intervals for protection management
  setInterval(toggleSwitchDefault, 50);
  setInterval(initProtection, 1000);

  if ($("discount-progress-bar").length > 0) {
    // Dynamically get reward IDs when needed
    thresholdRewardIds = getThresholdRewardIds();
    // Initialize discount progress bar
    initDiscountProgressBar();
  }
});

// ============================ Easter Discount Progress Bar =================================

// Function to check if a product was auto-added
function isAutoAddedItem(item) {
  return item.properties && item.properties[AUTO_ADDED_ATTRIBUTE] === "true";
}

// Function to batch update cart with multiple items (add multiple products in a single request)
function batchAddToCart(items) {
  return $.ajax({
    type: "POST",
    url: "/cart/add.js",
    data: {
      items: items,
    },
    dataType: "json",
  });
}

// Function to batch update cart with quantity changes (single API call)
function batchUpdateCart(updates) {
  return $.ajax({
    type: "POST",
    url: "/cart/update.js",
    data: {
      updates: updates,
    },
    dataType: "json",
  });
}

// Function to manage threshold rewards
function manageThresholdRewards(cart, thresholds) {
  const log = window.log;
  // Get current reward IDs
  const currentRewardIds = Object.values(thresholdRewardIds).filter(Boolean);
  log.collapse({ currentRewardIds }, "Current Reward IDs", "info");

  // Identify reward products in cart
  const rewardItems = cart.items.filter((item) =>
    currentRewardIds.includes(item.variant_id)
  );
  const autoAddedRewardItems = rewardItems.filter(isAutoAddedItem);

  // If cart only contains reward products, remove all auto-added ones
  if (
    cart.items.length === rewardItems.length &&
    autoAddedRewardItems.length > 0
  ) {
    log("Cart only contains rewards - removing auto-added items");
    // Use batch update instead of multiple individual requests
    const updates = {};
    autoAddedRewardItems.forEach((item) => {
      updates[item.key] = 0;
    });

    return batchUpdateCart(updates).then(() => refreshCartDrawer());
  }

  // Calculate total price excluding reward products
  const totalPrice =
    cart.items.reduce((sum, item) => {
      if (currentRewardIds.includes(item.variant_id)) return sum;
      return item.requires_shipping ||
        item.handle.includes("shipping-protection")
        ? sum + item.final_line_price
        : sum;
    }, 0) -
    cart.cart_level_discount_applications.reduce(
      (sum, discount) => sum + discount.total_allocated_amount,
      0
    );

  // Get valid thresholds & determine which are reached
  const validThresholds = thresholds
    .filter((t) => t && t.value !== undefined)
    .sort((a, b) => a.value - b.value);

  const reachedThresholds = [];
  validThresholds.forEach((threshold, index) => {
    if (totalPrice >= threshold.value) reachedThresholds.push(index + 1);
  });

  // Track all reward items by threshold index
  const rewardItemsByThreshold = {};
  const autoRewardItemsByThreshold = {};
  const manualRewardByThreshold = {};

  // Initialize with empty arrays
  Object.keys(thresholdRewardIds).forEach((index) => {
    const rewardId = thresholdRewardIds[index];
    if (rewardId) {
      rewardItemsByThreshold[index] = cart.items.filter(
        (item) => item.variant_id == rewardId
      );
      autoRewardItemsByThreshold[index] =
        rewardItemsByThreshold[index].filter(isAutoAddedItem);
      manualRewardByThreshold[index] = rewardItemsByThreshold[index].some(
        (item) => !isAutoAddedItem(item)
      );
    }
  });

  // Batch processing variables
  const itemsToAdd = [];
  const updates = {};
  let hasChanges = false;

  // Only manage rewards if cart has actual products
  if (totalPrice > 0) {
    // Process each threshold that has a reward product
    Object.keys(thresholdRewardIds).forEach((index) => {
      const rewardId = thresholdRewardIds[index];
      // Skip if no reward ID for this threshold
      if (!rewardId) return;

      const thresholdItems = rewardItemsByThreshold[index] || [];
      const autoItems = autoRewardItemsByThreshold[index] || [];
      const hasManual = manualRewardByThreshold[index] || false;

      // If threshold reached, add reward if needed
      if (reachedThresholds.includes(parseInt(index))) {
        if (thresholdItems.length === 0) {
          // Add to batch add request instead of individual API call
          itemsToAdd.push({
            id: rewardId,
            quantity: 1,
            properties: { [AUTO_ADDED_ATTRIBUTE]: "true" },
          });
          hasChanges = true;
        } else if (
          autoItems.length > 1 ||
          (autoItems.length > 0 &&
            !hasManual &&
            thresholdItems.reduce((sum, item) => sum + item.quantity, 0) > 1)
        ) {
          // Mark items for removal in batch update
          autoItems.forEach((item) => {
            updates[item.key] = 0;
          });

          // Add new item
          itemsToAdd.push({
            id: rewardId,
            quantity: 1,
            properties: { [AUTO_ADDED_ATTRIBUTE]: "true" },
          });
          hasChanges = true;
        }
      } else if (autoItems.length > 0) {
        // If threshold not reached, mark auto-rewards for removal in batch update
        autoItems.forEach((item) => {
          updates[item.key] = 0;
        });
        hasChanges = true;
      }
    });
  } else {
    // If cart is effectively empty, mark all auto-rewards for removal
    autoAddedRewardItems.forEach((item) => {
      updates[item.key] = 0;
    });
    hasChanges = autoAddedRewardItems.length > 0;
  }

  // Execute batch updates if needed
  if (hasChanges) {
    // Chain of operations
    let updatePromise = Promise.resolve();

    // First process any removals if needed
    if (Object.keys(updates).length > 0) {
      updatePromise = batchUpdateCart(updates);
    }

    // Then add any new items if needed
    if (itemsToAdd.length > 0) {
      updatePromise = updatePromise.then(() => {
        return batchAddToCart(itemsToAdd);
      });
    }

    // Finally refresh the cart UI
    return updatePromise.then(() => refreshCartDrawer());
  }

  return Promise.resolve();
}

function updateDiscountProgressBar(
  cart,
  currency,
  discountProgressBar,
  barIndex = 0
) {
  const log = window.log;
  const easterBar = discountProgressBar.length > 0;
  const $progressBar = discountProgressBar.find(".discount-bar__progress-bar");
  const $progressFill = discountProgressBar.find(
    ".discount-bar__progress-fill"
  );
  const $statusMessageElement = discountProgressBar.find(
    ".discount-bar__status"
  );

  // Get current reward IDs
  const currentRewardIds = Object.values(thresholdRewardIds).filter(Boolean);

  // Find all reward products to exclude them from calculations
  const rewardProducts = cart.items.filter((item) =>
    currentRewardIds.includes(item.variant_id)
  );

  // Log reward products for debugging
  log.collapse(
    {
      rewardProducts: rewardProducts.map((item) => ({
        title: item.title,
        variant_id: item.variant_id,
        price: item.final_line_price / 100,
      })),
      barIndex: barIndex,
    },
    `Reward Products (excluded from calculations) - Bar #${barIndex}`,
    "info"
  );

  // Calculate total price without reward products
  let totalPrice = 0;
  cart.items.forEach((item) => {
    // Skip reward products
    if (currentRewardIds.includes(item.variant_id)) {
      return;
    }

    if (item.requires_shipping || item.handle.includes("shipping-protection")) {
      totalPrice += item.final_line_price;
    }
  });

  // Apply cart-level discounts
  const cartDiscount = cart.cart_level_discount_applications.reduce(
    (sum, discountAllocation) =>
      sum + discountAllocation.total_allocated_amount,
    0
  );
  totalPrice -= cartDiscount;

  // Log the calculated price
  log.collapse(
    {
      totalPrice: totalPrice,
      formattedPrice: (totalPrice / 100).toFixed(2),
      cartDiscount: cartDiscount / 100,
      barIndex: barIndex,
    },
    `Cart Total (excluding rewards) - Bar #${barIndex}`,
    "info"
  );

  // Initialize thresholds from this specific progress bar only
  const thresholds = [];
  discountProgressBar.find(".discount-bar__threshold").each(function () {
    thresholds.push({
      value: parseFloat($(this).data("value")),
      text: $(this).find(".discount-bar__threshold-text").text(),
      isDiscount: $(this).data("discount") === "true",
      element: $(this),
    });
  });

  // Log thresholds for this specific bar
  log.collapse(
    {
      thresholdsCount: thresholds.length,
      thresholdValues: thresholds.map((t) => t.value),
      barIndex: barIndex,
    },
    `Thresholds for Bar #${barIndex}`,
    "info"
  );

  let fillPercentage = 0;
  let freeShippingUnlocked = false;
  let highestDiscountUnlocked = null;
  let nextThreshold = null;
  const progressStep = 100 / thresholds.length;

  // Reset the 'filled' class for thresholds that should no longer be filled
  thresholds.forEach((threshold) => {
    threshold.element.removeClass("discount-bar__threshold--filled");
  });

  if (easterBar) {
    thresholds.sort((a, b) => a.value - b.value);
    const minThreshold = thresholds[0]?.value || 0;
    const maxThreshold =
      thresholds[thresholds.length - 1]?.value || minThreshold;

    let prevThresholdValue = minThreshold;

    if (totalPrice >= maxThreshold) {
      // If we've reached the max threshold, fill to 100%
      fillPercentage = 100;
      thresholds.forEach((threshold) => {
        threshold.element.addClass("discount-bar__threshold--filled");
        if (threshold.isDiscount) highestDiscountUnlocked = threshold.text;
        else freeShippingUnlocked = true;
      });
    } else if (totalPrice > minThreshold) {
      // Process thresholds we've passed and find the next threshold
      for (let i = 0; i < thresholds.length; i++) {
        const threshold = thresholds[i];

        if (totalPrice >= threshold.value) {
          threshold.element.addClass("discount-bar__threshold--filled");
          if (threshold.isDiscount) highestDiscountUnlocked = threshold.text;
          else freeShippingUnlocked = true;
          prevThresholdValue = threshold.value;

          if (
            i < thresholds.length - 1 &&
            totalPrice < thresholds[i + 1].value
          ) {
            nextThreshold = thresholds[i + 1];
            // Calculate percentage based on position between thresholds
            const totalRange = maxThreshold - minThreshold;
            const currentPosition = totalPrice - minThreshold;
            const nextPosition = thresholds[i + 1].value - minThreshold;
            const prevPosition = prevThresholdValue - minThreshold;

            fillPercentage =
              (prevPosition / totalRange) * 100 +
              ((currentPosition - prevPosition) /
                (nextPosition - prevPosition)) *
              ((nextPosition / totalRange) * 100 -
                (prevPosition / totalRange) * 100);
            break;
          }
        } else {
          nextThreshold = threshold;
          // Calculate percentage to the next threshold
          fillPercentage =
            ((((totalPrice - minThreshold) / (threshold.value - minThreshold)) *
              (threshold.value - minThreshold)) /
              (maxThreshold - minThreshold)) *
            100;
          break;
        }
      }
    }
  } else {
    thresholds.forEach((threshold, index) => {
      const prevValue = thresholds[index - 1]?.value || 0;

      if (totalPrice >= threshold.value) {
        fillPercentage = (index + 1) * progressStep;
        threshold.element.addClass("discount-bar__threshold--filled");
        if (threshold.isDiscount) {
          highestDiscountUnlocked = threshold.text;
        } else freeShippingUnlocked = true;
      } else if (totalPrice > prevValue) {
        const range = threshold.value - prevValue;
        fillPercentage =
          index * progressStep +
          ((totalPrice - prevValue) / range) * progressStep;
        if (!nextThreshold) nextThreshold = threshold;
      } else if (!nextThreshold) nextThreshold = threshold;
    });
  }

  // Log progress bar calculation
  log.collapse(
    {
      fillPercentage,
      totalPrice: totalPrice / 100,
      thresholds: thresholds.map((t) => t.value / 100),
      barIndex: barIndex,
    },
    `Progress Bar Fill - Bar #${barIndex}`,
    "info"
  );

  $progressFill.css("width", `${fillPercentage}%`);

  // Update status message
  let message = "";
  if (!easterBar && freeShippingUnlocked)
    message =
      'Congratulations! You\'ve unlocked <span class="discount-bar__status-value">Free Shipping</span>!';
  if (!easterBar && highestDiscountUnlocked)
    message += message ? " & " : "" + highestDiscountUnlocked;
  if (easterBar && !nextThreshold)
    message = "Congratulations! You've unlocked everything!";
  if (nextThreshold) {
    const remaining = ((nextThreshold.value - totalPrice) * 0.01).toFixed(2);
    log.collapse(
      {
        nextThreshold: nextThreshold,
        nextThresholdText: nextThreshold.text,
        nextThresholdValue: nextThreshold.value,
        totalPrice: totalPrice,
        "nextThresholdValue - totalPrice": nextThreshold.value - totalPrice,
        remaining: remaining,
        currency: currency,
        barIndex: barIndex,
      },
      `REMAINING - Bar #${barIndex}`
    );
    const currency_symbol = $("<div>").html(currency).text();
    const thresholdText = nextThreshold.text
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
    message +=
      (!easterBar && message ? ". " : "") +
      `Only ${currency_symbol + remaining} left to unlock <span class="discount-bar__status-value">${thresholdText}</span>`;
  }

  $statusMessageElement.html(message);

  // Only manage threshold rewards for the first progress bar to avoid duplicates
  if (barIndex === 0) {
    // Manage threshold rewards based on cart state
    manageThresholdRewards(cart, thresholds);
  }
}
